<template>
  <SidebarLayout>
    <ul class="list-menu">
      <li>
        <router-link to="/dashboard">
          <img class="icon" :src="dashboardIcon" />
          <span class="text-menu">Dashboard</span>
        </router-link>
      </li>

      <li>
        <router-link to="/lists/my-lists">
          <img class="icon" :src="listingsIcon" />
          <span class="text-menu">My Listings</span>
        </router-link>
      </li>

      <li>
        <router-link to="/contests">
          <img class="icon" :src="contestsIcon" />
          <span class="text-menu">Contests</span>
        </router-link>
      </li>

      <li>
        <router-link to="/analytics">
          <img class="icon" :src="analyticIcon" />
          <span class="text-menu">Analytics</span>
        </router-link>
      </li>
      <li>
        <router-link to="/rewarder">
          <img class="icon" :src="rewarderIcon" />
          <span class="text-menu">Rewarder</span>
        </router-link>
      </li>
      <li>
        <router-link to="/trainer">
          <img class="icon" :src="trainerIcon" />
          <span class="text-menu">Trainer</span>
        </router-link>
      </li>
      <li>
        <router-link to="/community">
          <img class="icon" :src="communityIcon" />
          <span class="text-menu">Community</span>
        </router-link>
      </li>
    </ul>
  </SidebarLayout>
</template>

<script>
import SidebarLayout from "./SidebarLayout";
import dashboardIcon from "@/assets/images/icons/ew-icon_dashboard.svg";
import listingsIcon from "@/assets/images/icons/ew-icon_listings.svg";
import contestsIcon from "@/assets/images/icons/ew-icon_contests.svg";
import analyticIcon from "@/assets/images/icons/ew-icon_analytics.svg";
import rewarderIcon from "@/assets/images/icons/ew-icon_rewards.svg";
import trainerIcon from "@/assets/images/icons/ew-icon_trainer.svg";
import communityIcon from "@/assets/images/icons/ew-icon_community.svg";

export default {
  components: {
    SidebarLayout,
  },
  data() {
    return {
      dashboardIcon,
      listingsIcon,
      contestsIcon,
      analyticIcon,
      rewarderIcon,
      trainerIcon,
      communityIcon
    };
  },
};
</script>